(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.mobile = window.oneadvanced.mobile || {};
    window.oneadvanced.mobile.filtertoggle = function () {
        //console.log("initialising mobile filtertoggle...");
        var $filters = $('aside.filters');
        if ($filters.length) {
            $filters.find('h3').click(function () {
                var $this = $(this);

                $this.next('ul').slideToggle();
                $this.toggleClass('open');
            });
        }
    };
    window.oneadvanced.mobile.navigation = function () {
        //console.log("initialising mobile navigation...");
        var $triggers = $('.icon-link');
        if ($triggers.length) {
            $triggers.unbind().click(function (e) {
                e.preventDefault();
                var $this = $(this),
                    $parentLi = $this.parent('li'),
                    $parentUl = $parentLi.parent('ul');

                if (!$this.hasClass('open')) {
                    var $openLi = $parentUl.find('li.dropdown-active');
                    if ($openLi.length) {
                        $openLi.find('ul').first().slideToggle();
                        $openLi.toggleClass('dropdown-active');
                        $openLi.find('.open').toggleClass('open');
                    }
                }

                $parentLi.find('ul').first().slideToggle();
                $parentLi.toggleClass('dropdown-active');
                $this.toggleClass('open');
            });
        }

        if (!Foundation.MediaQuery.atLeast('large')) {
            var menuTrigger = $('#mobile-menu-trigger');
            var burgerMenu = $('#mobile-menu-trigger > button');
            var primaryNav = $('#primary-nav');
            burgerMenu.on('click', function () {
                menuTrigger.toggleClass('menu-open');
                primaryNav.toggleClass('show');
            });
        }
    };
    window.oneadvanced.mobile.auxlinks = function () {
        //console.log("initialising mobile auxlinks...");
        if (Foundation.MediaQuery.atLeast('large')) {
            Foundation.reInit($('[data-dropdown-menu]'));
        } else {
            var auxNavMenu = $('.navigationauxiliaryblock > ul.menu');
            if (auxNavMenu.length) {
                auxNavMenu.foundation('_destroy');
            }            
        }
    };
    window.oneadvanced.mobile.hasLoaded = true;

})();